import { Modal, ModalSizeEnum } from '@systemeio/ui'
import { useEffect, useRef, useState } from 'react'
import { Loader } from 'shared/components/loader'
import { getEventPreview } from '../api/events-api'
import { EventId } from '../types/event-interface'

interface PreviewModalProps {
  opened: boolean
  onClose: () => void
  eventId?: EventId
}

export const PreviewModal = ({ opened, onClose, eventId }: PreviewModalProps) => {
  const previewRef = useRef<HTMLIFrameElement>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const loadPreview = async () => {
      try {
        if (opened && eventId) {
          setIsLoading(true)
          const res = await getEventPreview(eventId)
          if (previewRef.current) {
            previewRef.current.srcdoc = res.data
          }
        }
      } catch (error) {
      } finally {
        setIsLoading(false)
      }
    }
    loadPreview()
  }, [opened, eventId])

  const onIframeLoad = () => {
    if (previewRef.current) {
      previewRef.current.height =
        previewRef.current.contentWindow?.document.body.scrollHeight + 'px'
    }
  }

  return (
    <Modal opened={opened} onClose={onClose} size={ModalSizeEnum.big} title={''} className="w-full">
      <div className="w-full max-w-7xl">
        {isLoading && (
          <div className="flex h-[500px] items-center justify-center">
            <Loader />
          </div>
        )}
        <iframe
          onLoad={onIframeLoad}
          ref={previewRef}
          width="100%"
          height={isLoading ? 0 : '500px'}
        />
      </div>
    </Modal>
  )
}
